import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { takeUntil } from 'rxjs/operators';
import { CustomResultOfPaginatedListOfPrivateReceiveKeywordsWithPaginationDto } from 'src/app/core/api/models';
import { AccountInformationDto } from '../../../../core/api/models/account-information-dto';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { PaginatedListOfPrivateReceiveKeywordsWithPaginationDto } from '.././../../../core/api/models/paginated-list-of-private-receive-keywords-with-pagination-dto';
import { PrivateReceiveKeywordsWithPaginationDto } from '.././../../../core/api/models/private-receive-keywords-with-pagination-dto';
import { ReceiveKeywordsService } from '.././../../../core/api/services/receive-keywords.service';
import { GetEnumValuesDto } from './../../../../core/api/models/get-enum-values-dto';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { PrivateReceiveKeywordsFormComponent } from './private-receive-keywords-form/private-receive-keywords-form.component';

@Component({
    selector: 'app-private-receive-keywords',
    templateUrl: './private-receive-keywords.component.html',
    styleUrls: ['./private-receive-keywords.component.scss'],
    imports: [BaseIndexModule, BaseFormModule, PrivateReceiveKeywordsFormComponent]
})
export class PrivateReceiveKeywordsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = 'assignNumbers.privateReceiveKeywords';
  protected currentService = inject(ReceiveKeywordsService);

  // Binding service endpoints
  paginationApiMethodName: string =
     this.currentService.receiveKeywordsGetPrivateReceiveKeywordsWithPagination.name;
  createGetApiMethodName: string =
     this.currentService.receiveKeywordsCreatePrivateReceiveKeywordGet.name;
  deleteApiMethodName: string =
     this.currentService.receiveKeywordsDelete.name;
  auditApiMethodName: string =
     this.currentService.receiveKeywordsGetReceiveKeywordsAudit.name;
  // Binding service endpoints  

  modelWithPagination$: Observable<PaginatedListOfPrivateReceiveKeywordsWithPaginationDto>;
  items$: Observable<Array<PrivateReceiveKeywordsWithPaginationDto>>;
  formPageConfig: FormPageConfig<AccountInformationDto> = {};

  UseTypesEnumValues: GetEnumValuesDto[] = [];
  SmsCpEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getEnumsValues() {
    this.getEnumValuesApi('UseTypes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.UseTypesEnumValues = values));
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsCpEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.number,
        name: 'number',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
      },
      { title: 'common.keyword', name: 'keyword', hasSearch: true },
      {
        title: this.localizer.price,
        name: 'price',
        needCurrency: true,
        hasSearch: true,
        type: 'number',
      },
      {
        title: 'common.useType',
        name: 'useType',
        hasSearch: true,
        type: 'enum',
        enumName: 'UseTypes',
      },
      {
        title: 'common.smsCp',
        name: 'smsCp',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmsCp',
      },
      {
        title: this.localizer.expireDate,
        name: 'expireDate',
        hasSearch: true,
        type: 'date',
      },
      {
        title: 'common.assignDate',
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: 'common.PrivateNumberCreated',
        name: 'PrivateNumberCreated',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .receiveKeywordsUpdatePrivateReceiveKeywordGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //#endregion
}
